/* eslint-disable no-console */
import { createSlice } from '@reduxjs/toolkit';
import { isObjectEmpty } from '../../shared/helper';
/* Added by Abhishek K
* make new reducer for each functionality, don't add here
*/
const intialValue = {};
export const myFilesResSlice = createSlice({
  name: 'myFilesRes',
  initialState: [10], // inital state like useState(..)
  reducers: {
    setMyFileRes: (state, action) => { // these are the actions
      state = action.payload;
      return state;
    },
    stripperDict: (state, action) => {
      const { record, type, id, item } = action.payload;
      const localData = intialValue[item] || {};
      if (isObjectEmpty(localData)) {
        if (isObjectEmpty(localData[type])) {
          localData[type][id] = record;
        } else {
          localData[type] = { [id]: record };
        }
      } else {
        localData[type] = { [id]: record };
      }
      if (['', 'null', null].indexOf(localData) < 0) {
        intialValue[item] = localData;
      }
      return localData;
    },
    // Dec: (state, action) => { // yeh bhi action he hai
    //     return state = action.payload;
    // }
  }
});

export const { setMyFileRes, stripperDict } = myFilesResSlice.actions;

export default myFilesResSlice.reducer;